import { createFileRoute, redirect } from '@tanstack/react-router';
import { WelcomeScreen } from '@/features/onboarding/WelcomeScreen';
import { sessionQuery } from '@/lib/session';

export const Route = createFileRoute('/welcome')({
  // Mirrors the backend's WelcomeGate (bypass={onboarding} only): password,
  // decline-grace and tos are all still enforced, in that exact order
  // (docs/parity/auth-public.md §2.12, §3 "gate precedence"). Deliberately
  // NOT gated on onboarding_required itself - legacy renders this page fine
  // even for an already-onboarded user who navigates back to it.
  beforeLoad: async ({ context }) => {
    const s = await context.queryClient.ensureQueryData(sessionQuery);
    if (!s.authenticated) throw redirect({ to: '/login' });
    if (s.gates?.password_change_required) throw redirect({ to: '/change-password' });
    if (s.gates?.account_closed) throw redirect({ to: '/account-closed' });
    if (s.gates?.tos_required) throw redirect({ to: '/terms' });
  },
  component: WelcomeScreen,
});
